// this file is responsible for saving and retriving users settings to/from browser local storage
class UserSessionDataHandler {
  // default properties names inside user settings object in localStorage
  static defaultLanguage = 'defaultLanguage';

  static defaultControlPanelScreen = 'defaultControlPanelScreen';

  static defaultOrganization = 'organization';

  static defaultUserSettingsObject = 'userSettingsObject';

  static defaultJurisdiction = 'jurisdiction';

  static defaultJurisdictionWithBuffer = 'jurisdictionWithBuffer';

  static defaultCentroid = 'centroid';

  static defaultUsername = 'username';

  static defaultUserData = 'userData';

  static defaultToken = 'token';

  static defaultRefreshToken = 'refreshToken';

  static defaultSettings = 'settings';

  static defaultTheme = 'theme';

  static defaultBuffer = 'buffer';

  static defaultTiles = 'tiles';

  static defaultWeather = 'weather';

  static defaultOperations = 'operations';

  static defaultFilters = 'uavosFilters';

  static tmpFilters = 'tmpFilters';

  static defaultTimezone = 'defaultTimezone';

  static defaultDashboardExtent = 'dashboardExtent';

  static defaultDashboard = 'dashboard';

  static defaultFontSize = 'fontSize';

  static getUserSettingsObject = () =>
    JSON.parse(localStorage.getItem(this.defaultUserSettingsObject));

  static getFromUserSettingsObjectInStore = fieldName => {
    const data = localStorage.getItem(this.defaultUserSettingsObject);
    return data !== null ? JSON.parse(data)[fieldName] : null;
  };

  static getUserDataObject = () =>
    JSON.parse(localStorage.getItem(this.defaultUserData));

  static getToken = () => localStorage.getItem(this.defaultToken);

  static getRefreshToken = () => localStorage.getItem(this.defaultRefreshToken);

  static getDashboardConfig = () =>
    this.getFromUserSettingsObjectInStore(this.defaultDashboard) || [];

  static getUserConfigZones = () =>
    this.getFromUserSettingsObjectInStore(this.defaultDashboard)?.zones || [];

  static getTheme = () =>
    this.getFromUserSettingsObjectInStore(this.defaultTheme) || null;

  static getBuffer = () =>
    this.getFromUserSettingsObjectInStore(this.defaultBuffer);

  static getUserConfig = () =>
    JSON.parse(localStorage.getItem(this.defaultUserSettingsObject));

  static getOperations = () =>
    JSON.parse(localStorage.getItem(this.defaultOperations)) || [];

  static getUavosFilters = () =>
    this.getFromUserSettingsObjectInStore(this.defaultDashboard)?.uavos || [];

  static getStateOfDashboardApprovedAreas = () =>
    this.getFromUserSettingsObjectInStore(this.defaultDashboard)
      ?.approvedAreas || false;

  static getFontSize = () =>
    this.getFromUserSettingsObjectInStore(this.defaultFontSize) || null;

  static getTmpFilters = () =>
    JSON.parse(localStorage.getItem(this.tmpFilters)) || [];

  static getJurisdiction = () =>
    JSON.parse(localStorage.getItem(this.defaultJurisdiction)) || null;

  static getOrganization = () =>
    JSON.parse(localStorage.getItem(this.defaultOrganization)) || null;

  static getJurisdictionWithBuffer = () =>
    JSON.parse(localStorage.getItem(this.defaultJurisdictionWithBuffer)) ||
    null;

  static getDashboardExtent = () =>
    JSON.parse(localStorage.getItem(this.defaultDashboardExtent)) || null;

  static saveUserSettingsObject = userSettingsObject => {
    localStorage.setItem(
      this.defaultUserSettingsObject,
      JSON.stringify(userSettingsObject)
    );
  };

  static saveUserDataObject = dataObject => {
    localStorage.setItem(this.defaultUserData, JSON.stringify(dataObject));
  };

  static saveToUserSettingsObjectInStorage = (fieldName, value) => {
    const userSettingsObject = this.getUserSettingsObject();
    userSettingsObject[fieldName] = value;
    localStorage.setItem(
      this.defaultUserSettingsObject,
      JSON.stringify(userSettingsObject)
    );
  };

  static saveToken = token => {
    localStorage.setItem(this.defaultToken, token);
  };

  static saveRefreshToken = token => {
    localStorage.setItem(this.defaultRefreshToken, token);
  };

  static saveJurisdiction = jurisdiction =>
    localStorage.setItem(
      this.defaultJurisdiction,
      JSON.stringify(jurisdiction)
    );

  static saveJurisdictionWithBuffer = jurisdiction =>
    localStorage.setItem(
      this.defaultJurisdictionWithBuffer,
      JSON.stringify(jurisdiction)
    );

  static saveUavosFilters = uavosFilters => {
    const dashboardConf = this.getUserSettingsObject();
    if (!dashboardConf) return;
    const updated = {
      ...dashboardConf,
      dashboard: { ...dashboardConf.dashboard, uavos: uavosFilters },
    };
    localStorage.setItem(
      this.defaultUserSettingsObject,
      JSON.stringify(updated)
    );
  };

  static saveStateOfDashboardApprovedAreas = state => {
    const dashboardConf = this.getUserSettingsObject();
    if (!dashboardConf) return;
    const updated = {
      ...dashboardConf,
      dashboard: { ...dashboardConf.dashboard, approvedAreas: state },
    };
    localStorage.setItem(
      this.defaultUserSettingsObject,
      JSON.stringify(updated)
    );
  };

  static saveTmpFilters = tmpFilters =>
    localStorage.setItem(this.tmpFilters, JSON.stringify(tmpFilters));

  static saveDashboardExtent = dashboardExtent =>
    localStorage.setItem(
      this.defaultDashboardExtent,
      JSON.stringify(dashboardExtent)
    );

  static removeUserSettingsObject = () => {
    localStorage.removeItem(this.defaultUserSettingsObject);
  };

  static removeUserDataObject = () => {
    localStorage.removeItem(this.defaultUserData);
  };

  static removeToken = () => {
    localStorage.removeItem(this.defaultToken);
  };

  /// //////////////////// tmp /////////////////////////
  static getTmpZone = () => localStorage.getItem('tmpZone');

  static getTmpUavo = () => localStorage.getItem('tmpUavo');
}

export default UserSessionDataHandler;
